module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/SavoryStuffing-ca0790e8c703ae2c0f1215452d6125ba.jpg";